export const RelatedTransactionDetailComponent = {
  templateUrl:
    './app/ajs/_shared/components/related-transactions/related-transaction-detail.component.html',
  bindings: {
    item: '<',
  },
  controller: RelatedTransactionDetailController,
  controllerAs: 'vm',
};

RelatedTransactionDetailController.$inject = ['CONFIGURATIONS', 'userService'];

function RelatedTransactionDetailController(config, userService) {
  const vm = this;

  vm.dateDisplay = config.DATE_DISPLAY;

  vm.$onChanges = function () {
    // Initializers
    setTransactionData();
  };

  function setTransactionData() {
    vm.logs = {};

    let createdBy;
    let updatedBy;

    vm.info = {
      id: vm.item.data.id,
      date: vm.item.data.date,
      document_type: vm.item.data.document_type,
      notes: vm.item.data.notes,
      currency: vm.item.data.currency,
    };

    if (vm.item.logs.created_info) {
      vm.logs.created_on = vm.item.logs.created_info.created_at;
      vm.logs.ip_address = vm.item.logs.created_info.ip_address;
      createdBy = vm.item.logs.created_info.user_id;
    }

    if (vm.item.logs.updated_info) {
      vm.logs.updated_on = vm.item.logs.updated_info.created_at;
      updatedBy = vm.item.logs.updated_info.user_id;
    }

    getUsers(createdBy, updatedBy);

    let type = vm.item.data.document_type
      ? vm.item.data.document_type.transaction_type
      : vm.item.data.type;
    vm.hideElements = false;

    switch (type) {
      case 'invoices':
        vm.info.doc_number = vm.item.data.invoice_number ? vm.item.data.invoice_number : vm.item.data.payment_number;
        vm.info.total = vm.item.data.grand_total ? vm.item.data.grand_total : vm.item.data.amount;
        break;
      case 'bookings':
        vm.info.doc_number = vm.item.data.booking_number;
        vm.info.total = vm.item.data.total_price;
        break;
      case 'client_credit_notes':
        vm.info.doc_number = vm.item.data.credit_note_number;
        vm.info.total = vm.item.data.grand_total; // total_voucher
        break;
      case 'client_debit_notes':
        vm.info.doc_number = vm.item.data.debit_note_number;
        vm.info.total = vm.item.data.grand_total; // total_voucher
        break;
      case 'received_payments':
        vm.info.doc_number = vm.item.data.payment_number;
        vm.info.total = vm.item.data.amount;
        break;
      case 'bills':
        vm.info.doc_number = vm.item.data.bill_number;
        vm.info.total = vm.item.data.grand_total;
        break;
      case 'payment_providers':
        vm.info.doc_number = vm.item.data.payment_number;
        vm.info.total = vm.item.data.amount;
        break;
      case 'provider_credit_notes':
        vm.info.doc_number = vm.item.data.provider_credit_note_number;
        vm.info.total = vm.item.data.apply_to_items
          ? vm.item.data.grand_total
          : vm.item.data.amount;
        break;
      case 'outgoing':
        vm.info.doc_number = vm.item.data.outgoing_consecutive;
        vm.info.total = vm.item.data.amount;
        vm.hideElements = true;
        break;
    }
  }

  function getUsers(createdBy, updatedBy) {
    if (vm.users) {
      vm.logs.created_by = vm.users.find((user) => user.id === createdBy);
      vm.logs.updated_by = vm.users.find((user) => user.id === updatedBy);

      return;
    }

    vm.loadingUsers = true;
    userService.getUsers({ get: 'active', skip_check_role: true }).subscribe((response) => {
      vm.users = response;

      vm.logs.created_by = vm.users.find((user) => user.id === createdBy);
      vm.logs.updated_by = vm.users.find((user) => user.id === updatedBy);

      vm.loadingUsers = false;
    });
  }
}
